import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Delivery } from 'src/app/models/delivery.schema';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { DeliveryService } from 'src/app/services/delivery.service';

@Component({
  selector: 'app-otp-verification-pop-up',
  templateUrl: './otp-verification-pop-up.component.html',
  styleUrls: ['./otp-verification-pop-up.component.scss']
})
export class OtpVerificationPopUpComponent implements OnInit {

  otp: string = '';
  showError = false;
  loading = false;
  delivery: Delivery;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { delivery: Delivery },
    public dialogRef: MatDialogRef<OtpVerificationPopUpComponent>,
    private commanUsesService: CommanUsesService,
    private deliveryService: DeliveryService,
  ) { 
    this.delivery = this.data.delivery;
  }

  ngOnInit() { }

  async submitOTP() {
    try {
      if (!this.isValid || this.loading) return;
      this.loading = true;

      const result: boolean = await this.deliveryService.verifyCustomerOtp(this.delivery.id, this.otp);
      if(result) {
        this.commanUsesService.showSnackBar('OPT_VERIFIED');
        this.dialogRef.close({ delivery: this.delivery });
      } else {
        this.commanUsesService.showSnackBar('OPT_NOT_VERIFIED');
      }
    } catch (error) {
      const errorMessage: string = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errorMessage);
    } finally {
      this.loading = false;
    }
  }

  onInput(e: Event) {
    const target = e.target as HTMLInputElement;
    let value = target.value.replace(/[^0-9]/g, ''); 
    this.otp = value.slice(0, 6); 
    this.showError = !/^\d{6}$/.test(this.otp); 
  }

  async sendOtpToCustomer() {
    try {
      if (this.loading) return;

      if(this.delivery.smsPhoneNo) {
        this.loading = true;
        const result: boolean = await this.deliveryService.sendOtpToCustomer(this.delivery.id);
        if(result) {
          this.dialogRef.close({ delivery: this.delivery });
        } else {
          this.commanUsesService.showSnackBar("SOMETHING_WENT_WRONG");
        }
      } else {
        this.commanUsesService.showSnackBar("CUSTOMER_NUMBER_NOT_PROVIDED_CONTACT_TO_VENDOR");
        return;
      }
      
    } catch (error) {
      const errorMessage: string = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errorMessage);
    } finally {
      this.loading = false;
    }
  }

  get isValid(): boolean {
    return this.otp.length === 6; 
  }

}
